import { combineReducers } from "redux";

import appReducer from "./app/reducers";
import merchantReducer from "./merchant/reducers";
import accomodationReducer from "./merchant/accomodation/reducers";
import partnershipReducer from "./partnership/reducers";
import queriesReducer from "./queries/reducers";
import { reducer as formReducer } from "redux-form";
import { routerReducer } from "react-router-redux";

export default combineReducers({
  app: appReducer,
  merchant: merchantReducer,
  accomodation: accomodationReducer,
  partnership: partnershipReducer,
  queries: queriesReducer,
  router: routerReducer,
  form: formReducer,
});



// WEBPACK FOOTER //
// ./src/reducers.js